<script>
export default {
  name: 'OtherConfig',
}
</script>

<template>
<div>kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk</div>
</template>

<style scoped>

</style>